import { GridToolbarGroup } from './grid-toolbar-group';

/**
 * Config object for the toolbar plugin. It's a hash of toolbar options. The
 * keys are the name of the toolbars, the values are the options to construct
 * the ToolbarViews
 * @typedef {Object.<string, Object>} ToolbarPluginConfig
 */

/**
 * The product of the toolbar plugin.
 * @typedef {Object} ToolbarPluginProduct
 * @property {GridToolbarGroup} gridToolbarGroup -
 *    The toolbar mananger to query and control the toolbars
 */

export const toolbarPlugin = definePlugin => definePlugin('toolbar', [
  'config',
  'gridView',
], ({
  plugins: { toolbar: toolbars } = {},
} = {}, gridView) => {
  const gridToolbarGroup = new GridToolbarGroup({
    gridView,
    toolbars,
  });

  gridToolbarGroup.updateGridView();

  return { gridToolbarGroup };
});
